import React from "react";
import Typewriter from "typewriter-effect";
import IconRow from "./IconRow";

function Header() {
  return (
    <div className="grid grid-rows-1 col-2">
      <div className="max-w-2xl mt-8">
        <h1 className="text-4xl ml-5 mt-16 font-bold tracking-tight text-zinc-800 sm:text-5xl text-white">
          <Typewriter
            options={{
              strings: ["Developer", "Student", "Designer", "Engineer"],
              autoStart: true,
              loop: true,
              delay: 200,
            }}
          />
        </h1>
        <p className="text-base text-gray-400 ml-5 mt-10 leading-6">
          Hi, I'm Sean, a current sophomore at Purdue University and a
          self-taught developer. I’m studying Electrical Engineering with a certificate in Semiconductors and Microelectronics.
        </p>
        <p className="text-base text-gray-400 ml-5 mt-5 leading-6">

           Looking forward to connecting!
        </p>
       
        <p className="text-base text-gray-500 ml-5 mt-5 leading-6">
        Website last updated: 1/5/26
        </p>
        

        <IconRow />
      </div>
    </div>
  );
}

export default Header;
